namespace $.$$ {
	$mol_style_define( $shm_hitalama_skills_item, {
		minWidth: 0, width: '100%',
		Menu: { minWidth: 0, width: '100%' },
		// The actual link/group button already provides the standard button padding.
		Anchor: { padding: 0, minWidth: 0, width: '100%' },
		Group: { minWidth: 0, width: '100%', whiteSpace: 'normal', overflowWrap: 'anywhere' },
		Link: { flexDirection: 'column', alignItems: 'stretch', minWidth: 0, width: '100%' },
		Link_title: { minWidth: 0, maxWidth: '100%', whiteSpace: 'normal', overflowWrap: 'anywhere' },
		// Same secondary identifier treatment as application FQNs.
		Link_id: { font: { size: '.75rem' }, color: $mol_theme.shade, overflowWrap: 'anywhere' },
	})
}
